import React,{ useState , useEffect } from 'react';
import logo from '../../images/logo_purple.png';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomTextField,CustomButton } from "@tracknme/material-ui";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { ViacepApi } from '../../services/Apis';
import { zipCodeMask } from '../../utils/mask';
import Grid from '@material-ui/core/Grid';
import '../../mobile.css';


function Step4() {

  const dispatch = useDispatch();
  const { register,navigation } = useSelector(({register}) => register);
  const [postalCode,setPostalCode] = useState();
  const [street,setStreet] = useState();
  const [number,setNumber] = useState();
  const [city,setCity] = useState();
  const [state,setState] = useState();
  const [district,setDistrict] = useState();
  const [complement,setComplement] = useState();
  const [loadData,setLoadData] = useState(false);
  const [nextStep,setNextStep] = useState(false);

  useEffect(() => {

    if(!loadData && register && register.address ){
        
        let zipCode = zipCodeMask(register.address.postalCode);

        setPostalCode(zipCode);
        setStreet(register.address.street);
        setNumber(register.address.number);
        setCity(register.address.city);
        setState(register.address.state);
        setDistrict(register.address.district);
        setComplement(register.address.complement);
        setLoadData(true)

        dispatch(Actions.setNavigation(false));
    }

  }, [loadData,register,dispatch ]);
  

  const handleChangePostalCodeValue = ({target}) => {
    const { value } = target;

    let zipCode = zipCodeMask(value)
    setPostalCode(zipCode);
  }

  const handleChangeStreetValue = ({target}) => {
    const { value } = target;
    setStreet(value);
  }

  const handleChangeNumberValue = ({target}) => {
    const { value } = target;
    setNumber(value);
  }

  const handleChangeCityValue = ({target}) => {
    const { value } = target;
    setCity(value);
  }

  const handleChangeStateValue = ({target}) => {
    const { value } = target;
    setState(value);
  }

  const handleChangeDistrictValue = ({target}) => {
    const { value } = target;
    setDistrict(value);
  }

  const handleChangeComplementValue = ({target}) => {
    const { value } = target;
    setComplement(value);
  }


  function getViaCep (){

    ViacepApi.get(postalCode)
    .then(response => {
        
        if(response && response.data){
         if(response.data.cep) setPostalCode(response.data.cep);
         if(response.data.logradouro)setStreet(response.data.logradouro);
         if(response.data.gia)setNumber(response.data.gia);
         if(response.data.localidade)setCity(response.data.localidade);
         if(response.data.uf)setState(response.data.uf);
         if(response.data.bairro)setDistrict(response.data.bairro);
         if(response.data.complemento)setComplement(response.data.complemento);
       }
      
    })
    .catch(error => {
        console.log('error ->',error)
    });
   
  }

  useEffect(() => {
    
    if(postalCode && state && city && district && street && number  ){
    
      dispatch(Actions.setNavigation(false));
      
      let _register = register ? register : {};

      if(_register){
        _register['address'] = {
          "postalCode": postalCode.replace(/\D/g, ""),
          "state": state,
          "city": city,
          "district": district,
          "street":street,
          "number": number,
          "complement": complement,
          "reference": ""
        }
      }
         
      dispatch(Actions.setRegister(_register));
      setNextStep(true);
      
    }else if(!navigation){
      setNextStep(false);
    }
  }, [postalCode, state, city, district, street, number,navigation,dispatch,register,complement ]);

  
  function changeBackStepValue() {
    dispatch(Actions.setStep(4));
  }
  
  function changeNextStepValue() {
    dispatch(Actions.setStep(6));
  }

  return (
    <div className="menuMobile">
        <div className="containerMobile">
        
            <div className="containerImage" >
                <img src={logo} className="logo" alt="Trackn'Me" />
            </div>
      
            <div className="titleStep4" >
                <CustomLabel  label="Complete as informações da sua empresa:" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:700, color:'#4D39E9'}} />  
            </div>

             <div className="textField">
                <FormControl>
                    <CustomTextField id="cep_1" label="CEP:" value={postalCode}  name="cep_1" onChange={handleChangePostalCodeValue} variant="filled" placeholder="CEP" onBlur={() => getViaCep()}
                      onKeyPress={event => {
                          if (event.key === 'Enter') {
                            getViaCep()
                          }
                      }} style={{width:'84vw'}}/>  
                    <CustomTextField  label="Logradouro:" value={street}  name="logradouro_1" onChange={handleChangeStreetValue} variant="filled" placeholder="Logradouro" style={{width:'84vw'}}/>  
                    <CustomTextField  label="Número:" value={number}  name="numero_1" onChange={handleChangeNumberValue} variant="filled" placeholder="Número" style={{width:'84vw',minWidth:50}}/>  
                    <CustomTextField  label="Complemento:" value={complement}  name="complemento_1" onChange={handleChangeComplementValue} variant="filled" placeholder="Complemento" style={{width:'84vw',minWidth:50}}/>  
                    <CustomTextField  label="Bairro:" value={district}  name="district_1" onChange={handleChangeDistrictValue} variant="filled" placeholder="Bairro" style={{width:'84vw'}}/>  
                    <CustomTextField  label="Estado:" value={state}  name="state_4" onChange={handleChangeStateValue} variant="filled" placeholder="Estado" style={{width:'84vw'}}/>  
                    <CustomTextField  label="Cidade:" value={city}  name="city_1" onChange={handleChangeCityValue} variant="filled" placeholder="Cidade" style={{width:'84vw'}}/>  
                 
                </FormControl>  
                <div style={{height:100}}></div>
            </div>
         
          
        </div>

        <div className="footer">
          <Grid container spacing={1}>
            <Grid item xs={4}  >
             
              <div className="center">
                <CustomButton  id="button" disabled={false} onClick={() => changeBackStepValue()} variant="contained" color="primary" label="Voltar" style={{height:'40px',marginTop:'20px', color:'#4D39E9', backgroundColor:'white', border: '3px solid #4D39E9'}}/> 
              </div>
            </Grid>
            <Grid item xs={4} >
              <div className="center">
                <CustomLabel id="title" label=" Passo 5 – 6" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:400, color:'#929292', marginTop:'35px'}} />  
              </div>
            </Grid>
            <Grid item xs={4} >
            <div className="center"><CustomButton  id="button" disabled={false} onClick={() => nextStep ? changeNextStepValue() : {}} variant="contained" color="primary" label="Avançar" style={nextStep ? {height:'40px',marginTop:'20px'} : {height:'40px',marginTop:'20px',backgroundColor:'#BFBFBF'}}/> </div>
            </Grid>
          </Grid>
          
        </div>
        
       
        
     </div>
    
  );
}

export default Step4;

